
const swiper = new Swiper('.swiper-left', {
    loop: true,
    slidesPerView: '1',
    pagination: {
      el: '.slider-left-pagination',
    },
    navigation: {
      nextEl: '.slider-left-button-next',
      prevEl: '.slider-left-button-prev',
    },
  
});

const swiper2 = new Swiper('.swiper-right', {
  loop: true,
  slidesPerView: '1',
  pagination: {
    el: '.slider-right-pagination',
  },
  navigation: {
    nextEl: '.slider-right-button-next',
    prevEl: '.slider-right-button-prev',
  },

});

const swiper3 = new Swiper('.swiper-basic', {
  loop: true,
  slidesPerView: '1',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

});


const swiper4 = new Swiper('.swiper-main', {
  effect: 'slide',
  slidesPerView: '1',
  initialSlide: 2,
  loop: true,
  centeredSlides: true,
  lazyLoading: false,
  autoHeight: false,
  spaceBetween: 10,
  breakpoints: {
    991: {
       centeredSlides: false,
        initialSlide: 2,
        slidesPerView: 5,
        spaceBetween: 15,
    },
    1400: {
      centeredSlides: false,
      initialSlide: 2,
      slidesPerView: 6,
    },
  },

  pagination: {
    el: '.slider-main-pagination',
  },

  navigation: {
    nextEl: '.slider-main-button-next',
    prevEl: '.slider-main-button-prev',
  },

});